/** @file EFFECT_FRAGMENT_GLSL: effect sprites keep their straight colour and alpha for blending. */
import { SAMPLE_TILE_GLSL } from '@zilo/pose3d-runtime-babylon/draw/sampleTileGlsl';

/** `SAMPLE_TILE_GLSL` (cut discard included), discards fully transparent texels, writes the texel as it is. */
export const EFFECT_FRAGMENT_GLSL = `${SAMPLE_TILE_GLSL}
void main(void) {
  vec4 c = sampleTile();
  if (c.a <= 0.0) discard;
  gl_FragColor = c;
}
`;
